import { useQuery } from '@tanstack/react-query';

import getHostAccountPromo from 'Api/host-stock-promo/getHostAccountPromo';

import getAccountPromoResponse from './model/response/getHostAccountPromoResponse';

const useGetHostAccountPromo = ({ enabled }) => {
  return useQuery({
    queryKey: ['host-account-promo'],
    queryFn: async () => {
      const response = await getHostAccountPromo();

      const result = getAccountPromoResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled,
  });
};

export default useGetHostAccountPromo;
